import React, {FC, useEffect, useState} from "react";
import classNames from "classnames";
import {MenuInterface} from "../model/MenuInterface";
import {Link} from "react-router-dom";
import {getLink} from "../api/MenuApi";

type ContentHeaderProps = {
    subMenuList: MenuInterface[];
    activeMenuId: number;
}

const ContentHeader: FC<ContentHeaderProps> = (
    {
        subMenuList,
        activeMenuId
    }) => {

    const [environment, setEnvironment] = useState("");

    useEffect(() => {
        if (navigator.userAgent.match(/Android|Mobile|iP(hone|od|ad)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)) {
            setEnvironment('not-pc');   // 모바일(스마트폰+태블릿)일 때
        }
        // PC에서만 실행 될 스크립트   /*************** 테스트용 ***************/
        if (!navigator.userAgent.match(/Android|Mobile|iP(hone|od|ad)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)) {
            setEnvironment('pc');
            // setEnvironment('not-pc');
        }
    }, [environment]);

    const contentHeaderItems: JSX.Element[] =
        subMenuList.map((subMenu, idx) => {
            if(subMenu.menuNm === '데이터 신청'){
                subMenu.route = environment === 'not-pc' ? '#' : '/request';
            }
            const onClickDataRequest = () => {
                if (environment === 'not-pc' && subMenu.menuNm === '데이터 신청') {
                    alert('PC 환경에서 이용 바랍니다.');
                }
            }
            return (
                <Link to={getLink(subMenu)} key={idx} onClick={onClickDataRequest}>
                    <div className={classNames('content-header-item',
                            { 'active': activeMenuId === subMenu.menuId })}>
                        {subMenu.menuNm}
                    </div>
                </Link>
            );
        });

    return (
        <div className={'content-header-wrapper'}>
            <div className={'content-header-body'}>
                {contentHeaderItems}
            </div>
        </div>
    );
}

export default ContentHeader;
